module.exports = __webpack_public_path__ + "static/media/center-image-pointing-left.0a8547da.svg";